import { render, staticRenderFns } from "./PropertyClusters.vue?vue&type=template&id=0b31bf33&"
import script from "./PropertyClusters.vue?vue&type=script&lang=ts&"
export * from "./PropertyClusters.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyClusters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports